import classnames from 'classnames';

import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import { formatToReactComponent } from 'bloko/common/trl';

import HumanDate, { ShowYear } from 'src/components/HumanDate';
import translation from 'src/components/translation';
import { EmployerStateType, isDiscardEmployerState } from 'src/models/negotiationTopic.types';

import styles from './index.less';

const TrlKeys = {
    [EmployerStateType.Assessment]: 'resume.employer.history.ASSESSMENT',
    [EmployerStateType.Consider]: 'resume.employer.history.CONSIDER',
    [EmployerStateType.Hired]: 'resume.employer.history.HIRED',
    [EmployerStateType.Interview]: 'resume.employer.history.INTERVIEW',
    [EmployerStateType.Offer]: 'resume.employer.history.OFFER',
    [EmployerStateType.PhoneInterview]: 'resume.employer.history.PHONE_INTERVIEW',
    [EmployerStateType.Response]: 'resume.employer.history.RESPONSE',
    [EmployerStateType.DiscardByEmployer]: 'resume.employer.history.DISCARD_BY_EMPLOYER.softForm',
    [EmployerStateType.DiscardByApplicant]: 'resume.employer.history.DISCARD_BY_APPLICANT',
    [EmployerStateType.DiscardNoInteraction]: 'resume.employer.history.DISCARD_NO_INTERACTION',
    [EmployerStateType.DiscardVacancyClosed]: 'resume.employer.history.DISCARD_VACANCY_CLOSED',
    [EmployerStateType.DiscardToOtherVacancy]: 'resume.employer.history.DISCARD_TO_OTHER_VACANCY',
};

interface Props {
    state: Exclude<EmployerStateType, EmployerStateType.Invitation>;
    updated: string;
}

const Topic: TranslatedComponent<Props> = ({ state, updated, trls }) => (
    <span
        className={classnames(styles.state, {
            [styles.stateDiscard]: isDiscardEmployerState(state),
        })}
        data-qa="topic-state"
        data-qa-state={state}
    >
        {formatToReactComponent(trls[TrlKeys[state]], {
            '{0}': <HumanDate date={updated} showYear={ShowYear.NotCurrent} />,
        })}
    </span>
);

export default translation(Topic);
